const globalEnumPermData = {
    LANG_CATEGORY: {
        en: "英语",
        pt: "葡萄牙语",
        es: "西班牙语",
    },
    PERM_KEY: {
        DataStatistics: `stats`,
        DataStatistics_Dashboard: `realTimeStats`,
        DataStatistics_DomainStatistic: `domainStats`,
        DataStatistics_VideoStatistic: `resourceStats`,
        DataStatistics_AdsStatistic: `adStats`,

        ResourceManagement: `resource`,
        ResourceManagement_ResourceType: `resourceType`,
        ResourceManagement_TagManagement: `tab`,
        ResourceManagement_PopularSearch: `hot`,
        ResourceManagement_VideoManagement: `video`,
        ResourceManagement_CrawlingManagement: `crawl`,

        OperationManagement: `operation`,
        OperationManagement_BasicResource: `configuration`,
        OperationManagement_BannerManagement: `bannerAd`,
        OperationManagement_AppAdsManagement: `appAd`,
        OperationManagement_BannerAds: `sloganAd`,
        OperationManagement_AnnouncementAds: `publicAd`,
        OperationManagement_AppLaunchAds: `publicAd`,
        OperationManagement_IrregularAds: `customeAd`,
        OperationManagement_HeaderAds: `topAd`,
        OperationManagement_BottomAds: `bottomAd`,
        OperationManagement_HomeAds: `indexLiteralAd`,
        OperationManagement_DetailAds: `detailAd`,
        OperationManagement_VideoListAds: `vodListAd`,
        OperationManagement_RecommendAds: `recommendAd`,
        OperationManagement_BottomScrollAds: `bottomScrollAd`,
        OperationManagement_NineSquareAds: `nineSquareAd`,
        OperationManagement_ResourceTypeAds: `tabAdConfig`,
        OperationManagement_VideoPlayerAds: `videoPlayerAdConfig`,
        OperationManagement_PopupManagement: `popupSortList`,
        OperationManagement_CommentReview: `comment`,
        OperationManagement_AgentStatisticManagement: `agentStatisticManage`,
        OperationManagement_BlacklistManagement: `blacklist`,

        SystemManagement: `system`,
        SystemManagement_UserManagement: `administrator`,
        SystemManagement_PermissionManagement: `role`,
        SystemManagement_IpWhitelistManagement: `whiteIp`,
        SystemManagement_LogManagement: `log`,
    },
}

export default globalEnumPermData
